<app-progress-bar-overlay></app-progress-bar-overlay>

<div class="contenitore">
  <div class="titolo-pagina">
    <app-titolo-subtitolo
      titolo="Configurazione Prompt Generali"
      subTitolo="Definizione dei prompt generici per modulo."
    ></app-titolo-subtitolo>
  </div>

  <mat-tab-group (selectedTabChange)="onTabChange()">
    <ng-container [formGroup]="form">
      <ng-container formArrayName="promptAI">
        @for (group of promptAIArray.controls; track $index) {
          <mat-tab [label]="getlabelModulo(group.get('tipo')?.value) || 'Prompt ' + $index">
            <ng-template matTabContent>
              <div class="cnt-prompt" [formGroupName]="$index">
                <div class="titolo-e-tags">
                  <div class="desc-bott">
                    <div class="contenitore-titolo-subtitolo">
                      <div class="titolo-sezione-dialog">
                        Prompt generale per modulo {{ getlabelModulo(group.get('tipo')?.value) }}
                      </div>
                      <div class="descrizione-sezione-dialog">
                        Questo testo personalizzato verrà utilizzato dall'AI per l'interogazione sul
                        modulo
                        {{ getlabelModulo(group.get('tipo')?.value) }}.
                      </div>
                    </div>
                  </div>
                  <div>
                    <button
                      mat-flat-button
                      color="primary"
                      [matMenuTriggerFor]="menu"
                      class="primary-button tags"
                    >
                      Placeholders
                    </button>
                    <mat-menu #menu="matMenu">
                      <div class="legenda-info">
                        <p>
                          Clicca per copiare i placeholders negli appunti ed incollalo nel testo del
                          template.
                        </p>
                        <p>
                          I placeholders aggiunti al testo saranno sostituiti con il contenuto
                          relativo durante l'elaborazione.
                        </p>
                      </div>
                      @for (plchld of placeholders; track $index) {
                        @if (plchld.tipoModulo.includes(group.get('tipo')?.value)) {
                          <button (click)="copiaPlaceholder(plchld.chiave)" mat-menu-item>
                            {{ plchld.label }}
                          </button>
                        }
                      }
                    </mat-menu>
                  </div>
                </div>
                <div class="editor-cont" appFormContainer [larghezza]="1">
                  <mat-form-field
                    (mousedown)="$event.stopPropagation()"
                    appFormElement
                    [larghezza]="1"
                    [riempi]="true"
                  >
                    <mat-label>Prompt AI</mat-label>

                    <textarea
                      matInput
                      formControlName="prompt"
                      (input)="adjustHeight($event)"
                      placeholder="Descrizione"
                    ></textarea>

                    <mat-hint class="hint-prompt">
                      I placeholders aggiunti al testo saranno sostituiti con il contenuto relativo
                      durante l'elaborazione.
                    </mat-hint>
                  </mat-form-field>
                </div>

                <div class="btn-container">
                  <button
                    mat-flat-button
                    color="primary"
                    (click)="salva(group)"
                    class="primary-button salva"
                  >
                    Salva
                  </button>
                </div>
              </div>
            </ng-template>
          </mat-tab>
        }
      </ng-container>
    </ng-container>
  </mat-tab-group>
</div>
